import { Icon } from "@helmr/ui";
import type { MessageStatus } from "../../api/inbox";
import { inbox as t } from "./strings";
import s from "./inbox.module.css";

/** pending (clock), sent (one tick), delivered (two), read (two, blue), failed (alert). */
export function StatusTick({ status }: { status: MessageStatus }) {
  const icon = status === "pending" ? "clock" : status === "sent" ? "check" : status === "failed" ? "alert" : "tick2";
  return <span className={s.mk} data-st={status} role="img" aria-label={t.status[status]}><Icon name={icon} size={16} /></span>;
}
